<app-form
  [widgetId]="widgetId"
  [dataGroupItemInstance]="dataGroupItemInstance"
  [rowIndex]="0"
  [nav]="dataGroupItemInstance.rowOptions.nav"
  [formClass]="formClass"
  [navList]= "['primary', 'secondary']">
</app-form>
